import { atom } from 'recoil';

export const pendingShareProjectState = atom({
  key: 'Projects/pendingShareProjectState',
  default: false,
});
